<div class="container">
  <form (submit)="confirmChanges($event)">
    <abc-text-box
      #nameTextBox
      [label]="translation?.name"
      [(value)]="parameterDefinition.Name"
      valueChangeEvent="keyup"
      [disabled]="initialized"
      >
      <dx-validator>
        <dxi-validator-validation-rule
          #nameValidationRule
          type="async"
          [validationCallback]="nameValidator"
        ></dxi-validator-validation-rule>
        <dxi-validator-validation-rule type="required" [message]="translation?.nameRequired"></dxi-validator-validation-rule>
      </dx-validator>
    </abc-text-box>
    <abc-text-box
      #captionTextBox
      [label]="translation?.label"
      [(value)]="parameterDefinition.Caption"
      valueChangeEvent="keyup"
      >
    </abc-text-box>
    <abc-text-area
      [label]="translation?.description"
      [(value)]="parameterDefinition.Description"
      valueChangeEvent="keyup"
      >
    </abc-text-area>

    <abc-drop-down-box
      [label]="translation?.type"
      [(value)]="parameterDefinition.Type"
      [dataSource]="parameterTypeDatasource"
      [gridColumns]="[{ dataField: 'displayText' }]"
      [hideColumnHeaders]="true"
      valueExpr="value"
      displayExpr="displayText"
      [acceptCustomValue]="false"
    ></abc-drop-down-box>

    @if (parameterDefinition.Type === ParameterType.String) {
      <abc-text-box
        [label]="translation?.defaultValue"
        [(value)]="parameterDefinition.Value"
        valueChangeEvent="keyup"
      ></abc-text-box>
    }
    @if (parameterDefinition.Type === ParameterType.Number) {
      <abc-number-box
        [label]="translation?.defaultValue"
        [(value)]="parameterDefinition.Value"
        valueChangeEvent="keyup"
      ></abc-number-box>
    }
    @if (parameterDefinition.Type === ParameterType.Date) {
      <abc-date-box
        [label]="translation?.defaultValue"
        [(value)]="parameterDefinition.Value"
        valueChangeEvent="keyup"
      ></abc-date-box>
    }
    @if (parameterDefinition.Type === ParameterType.Boolean) {
      <abc-check-box
      [text]="
        parameterDefinition.Value
          ? translation?.defaultValue + ' : ' + translation?.yes
          : translation?.defaultValue + ' : ' + translation?.no
      "
        [(value)]="parameterDefinition.Value"
        valueChangeEvent="keyup"
        >
      </abc-check-box>
    }
    @if (
      parameterDefinition.Type === ParameterType.DataAccessByValue ||
      parameterDefinition.Type === ParameterType.DataAccessByObjectType ||
      parameterDefinition.Type === ParameterType.PicklistByName ||
      parameterDefinition.Type === ParameterType.PicklistByColumn ||
      parameterDefinition.Type === ParameterType.Query ||
      parameterDefinition.Type === ParameterType.ContextSetting
      ) {
      <abc-check-box
        [(value)]="parameterDefinition.AllowMultiSelect"
        [text]="translation?.multiSelection"
        >
      </abc-check-box>
    }
    <abc-check-box [(value)]="parameterDefinition.IsRequired" [text]="translation?.requiredInput"> </abc-check-box>
    @if (
      !(
      parameterDefinition.Type === ParameterType.DataAccessByValue ||
      parameterDefinition.Type === ParameterType.DataAccessByObjectType ||
      parameterDefinition.Type === ParameterType.PicklistByName ||
      parameterDefinition.Type === ParameterType.PicklistByColumn
      )
      ) {
      <abc-check-box
        [(value)]="parameterDefinition.IsFixed"
        [text]="translation?.alwaysDefaultValue"
      ></abc-check-box>
    }
    @if (parameterDefinition.Type === ParameterType.Number || parameterDefinition.Type === ParameterType.Date) {
      <abc-text-box
        [label]="translation?.editMask"
        [(value)]="parameterDefinition.EditMask"
        valueChangeEvent="keyup"
      ></abc-text-box>
    }
    @if (parameterDefinition.Type === ParameterType.Number) {
      <abc-number-box
        [label]="translation?.minValue"
        [(value)]="parameterDefinition.MinNumberValue"
        valueChangeEvent="keyup"
        >
        <dx-validator>
          <dxi-validator-validation-rule
            [message]="translation?.invalidValue"
            type="async"
            [validationCallback]="minNumberValidator"
          ></dxi-validator-validation-rule>
        </dx-validator>
      </abc-number-box>
    }
    @if (parameterDefinition.Type === ParameterType.Number) {
      <abc-number-box
        [label]="translation?.maxValue"
        [(value)]="parameterDefinition.MaxNumberValue"
        valueChangeEvent="keyup"
        >
        <dx-validator>
          <dxi-validator-validation-rule
            [message]="translation?.invalidValue"
            type="async"
            [validationCallback]="maxNumberValidator"
          ></dxi-validator-validation-rule>
        </dx-validator>
      </abc-number-box>
    }
    @if (parameterDefinition.Type === ParameterType.Date) {
      <abc-date-box
        [(value)]="parameterDefinition.MinDateValue"
        [label]="translation?.minValue"
        valueChangeEvent="keyup"
        >
        <dx-validator>
          <dxi-validator-validation-rule
            [message]="translation?.invalidValue"
            type="async"
            [validationCallback]="minDateValidator"
          ></dxi-validator-validation-rule>
        </dx-validator>
      </abc-date-box>
    }
    @if (parameterDefinition.Type === ParameterType.Date) {
      <abc-date-box
        [(value)]="parameterDefinition.MaxDateValue"
        [label]="translation?.maxValue"
        valueChangeEvent="keyup"
        >
        <dx-validator>
          <dxi-validator-validation-rule
            [message]="translation?.invalidValue"
            type="async"
            [validationCallback]="maxDateValidator"
          ></dxi-validator-validation-rule>
        </dx-validator>
      </abc-date-box>
    }
    @if (
      parameterDefinition.Type === ParameterType.DataAccessByValue ||
      parameterDefinition.Type === ParameterType.DataAccessByObjectType ||
      parameterDefinition.Type === ParameterType.PicklistByName ||
      parameterDefinition.Type === ParameterType.PicklistByColumn ||
      parameterDefinition.Type === ParameterType.Query ||
      parameterDefinition.Type === ParameterType.ContextSetting
      ) {
      <abc-drop-down-box
        #parameterValueDropDownBox
        [hideColumnHeaders]="true"
        [acceptCustomValue]="true"
        [label]="translation?.title"
        [(value)]="parameterDefinition.DataArgument"
        [buttons]="parameterDefinition.Type === ParameterType.Query ? queryButtons : defaultParameterValueButtons"
      ></abc-drop-down-box>
    }
    @if (parameterDefinition.Type === ParameterType.DataAccessByObjectType) {
      <abc-text-box
        [disabled]="!parameterDefinition.DataArgument"
        [label]="translation?.filterCondition"
        [value]="parameterDefinition.DataArgument2"
        [buttons]="objectSelectionButtons"
        valueChangeEvent="keyup"
      ></abc-text-box>
    }
    @if (parameterDefinition.Type === ParameterType.DataAccessByValue) {
      <abc-drop-down-box
        #valueSelectionExpressionDropDownBox
        [disabled]="!parameterDefinition.DataArgument"
        [label]="translation?.columnExpression"
        [(value)]="parameterDefinition.DataArgument2"
        [buttons]="valueSelectionButtons"
        [hideColumnHeaders]="true"
        [acceptCustomValue]="true"
      ></abc-drop-down-box>
    }
    @if (parameterDefinition.Type === ParameterType.Query) {
      <abc-drop-down-box
        [disabled]="false"
        [hideColumnHeaders]="true"
        [displayExpr]="'DisplayText'"
        [valueExpr]="'Name'"
        [gridColumns]="[{ dataField: 'DisplayText', name: 'DisplayText' }]"
        [label]="translation?.column"
        [value]="parameterDefinition.DataArgument2"
      ></abc-drop-down-box>
    }
    @if (parameterDefinition.Type === ParameterType.ContextSetting) {
      <abc-drop-down-box
        [disabled]="false"
        [hideColumnHeaders]="true"
        [displayExpr]="'DisplayText'"
        [valueExpr]="'Name'"
        [gridColumns]="[{ dataField: 'DisplayText', name: 'DisplayText' }]"
        [label]="translation?.column"
        [value]="parameterDefinition.DataArgument2"
      ></abc-drop-down-box>
    }
    @if (parameterDefinition.Type === ParameterType.ValueExpression) {
      <abc-text-area
        [(value)]="parameterDefinition.DataArgument2"
        [label]="translation?.cSharpExpression"
        valueChangeEvent="keyup"
        >
        <dx-validator>
          <dxi-validator-validation-rule type="required" [message]="translation?.cSharpExpressionRequired"></dxi-validator-validation-rule
          ></dx-validator>
        </abc-text-area>
      }
      <div class="form-controls">
        <abc-button
          width="100%"
          [text]="translation?.save"
          [useSubmitBehavior]="true"
          [disabled]="!parameterDefinition.Name"
          ></abc-button
          ><abc-button
          width="100%"
          [text]="translation?.cancel"
          (onClick)="initialized ? cancelChanges(parameterDefinitionsBackup) : cancelChanges()"
        ></abc-button>
      </div>
    </form>
  </div>
